import { useWebSocket } from '../../contexts/backend/WebSocketContext';
import { User } from '../../contexts/backend/ws-types-and-normalizers';

export interface UseUserDataReturn {
  user: User | null;
  isLoading: boolean;
  isConnected: boolean;
  refresh: () => Promise<void>;
}

export function useUserData(): UseUserDataReturn {
  const { status, data, ensureUser } = useWebSocket();

  const isLoading = status === 'connecting' || (status === 'open' && !data.user);
  const isConnected = status === 'open';

  return {
    user: data.user,
    isLoading,
    isConnected,
    refresh: ensureUser,
  };
}
